module.exports = __webpack_public_path__ + "static/media/edit-restaurant.d6a08f8f.svg";